module.exports = window["mixitup"];